import { jsx as m } from "react/jsx-runtime";
import { c as a } from "../../../index-Cu0xwYjD.js";
import { s as e } from "../../../Grid.module-BpY5QcAG.js";
const p = ({
  children: s,
  className: r,
  style: o,
  ...t
}) => /* @__PURE__ */ m(
  "div",
  {
    className: a(e.grid, r),
    style: o,
    ...t,
    children: s
  }
);
export {
  p as ContentGrid
};
